// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cd73bdc8","703":"aed2174d"}[chunkId] + ".chunk.js";
};